export default "__VITE_ASSET__9b5b0775__"